export default __webpack_public_path__ + "9565527b3b056d0dc5d0230bbf596fef.woff";